
<template>
  <div>
    <div class="formBox" ref="searchBox">
      <el-form  :inline="true"  :model="searchFrom" ref="searchFrom" class="demo-form-inline"  label-width="100px"  size="mini"  >
       <div class="formItemBox">
            <el-form-item label="捆包编号">
              <el-input placeholder="可支持多个" type="textarea"  v-model="searchFrom.cargoBarcode" ></el-input>
            </el-form-item>
           <template v-for="(column,index) in searchList" >
              <el-form-item label="结算客户:" v-if="column.enName=='payee'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.payee" filterable placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in kehuList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="货物类型:" v-else-if="column.enName=='productTypeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.productType" filterable placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in HWlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否一票制:"  v-else-if="column.enName=='ticketSystemYn'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.ticketSystemYn" filterable placeholder="请选择" >
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="是" value="是" ></el-option>
                  <el-option  label="否" value="否" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单来源:"  v-else-if="column.enName=='orderSourceName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.orderSources" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="手动" value="0" ></el-option>
                  <el-option  label="转包" value="1" ></el-option>
                  <el-option  label="分段" value="3" ></el-option>
                  <el-option  label="货主端" value="8" ></el-option>
                  <el-option  label="首钢配载" value="9,11" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="配载方式:"  v-else-if="column.enName=='stowageTypeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.stowageType" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="指派" value="0" ></el-option>
                  <el-option  label="转包" value="1" ></el-option>
                  <el-option  label="分段" value="2" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务类型:"  v-else-if="column.enName=='orderBusinessTypeName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.orderBusinessType" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in YWLXlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收入计价:"  v-else-if="column.enName=='revenueValuationName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.revenueValuation" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in SRJJlist"  :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务部门:"  v-else-if="column.enName=='businessSubunit'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.businessSubunit" filterable placeholder="请选择" @change="bumenChangeCX">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in bumenList" :label="item.name" :value="item.name" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务人员:"  v-else-if="column.enName=='businessUser'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select  v-model="searchFrom.businessUser" filterable placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in yonghuList" :label="item.userName" :value="item.userName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态:"  v-else-if="column.enName=='orderStateName'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-select v-model="searchFrom.orderStates" placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option  label="待处理+处理中" value="0,1" ></el-option>
                  <el-option  label="待处理" value="0" ></el-option>
                  <el-option  label="处理中" value="1" ></el-option>
                  <el-option  label="已处理" value="2" ></el-option>
                  <el-option  label="已作废" value="3" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="要求到达时间:" class="item2"  v-else-if="column.enName=='arrivalTime'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-date-picker
                    v-model="searchFrom.arrivalTimes"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="创建时间:" class="item2"  v-else-if="column.enName=='createTime'&&(index<seacrchNum||topShow)" :key="column.enName">
                <el-date-picker
                    v-model="searchFrom.createTimes"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
              <template  v-else>
                <el-form-item :label="column.cnName+':'" v-if="(index<seacrchNum||topShow)" :key="column.enName">
                  <el-input placeholder="" v-model="searchFrom[column.enName]" ></el-input>
                </el-form-item>
              </template>
           </template>
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox">
            <el-button type="primary" v-if="btnFlg[0]" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary"  size="mini" @click="resetForm('searchFrom')">重置</el-button>
             <el-button type="primary" v-if="btnFlg[1]"  size="mini" @click="exportFn" :disabled="isDisable">导出</el-button>
          </div>
          <div style="display: flex;">
            <!-- <el-button type="primary" v-if="btnFlg[0]" size="mini" @click="searchFn">切换样式</el-button> -->
            <div @click="tabSetting"><i class="el-icon-s-tools"></i></div>
          </div>

        </div>

      </el-form>
    </div>
    <div class="openBox">
      <div class="openChild" v-if="topShow" @click="topFn">
        <i class="el-icon-caret-top" ></i>
      </div>
      <div class="openChild" v-if="!topShow" @click="topFn">
        <i class="el-icon-caret-bottom" ></i>
      </div>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
      <el-table  :data="tableList"  ref="table" v-loading="loading" bordersize="mini" @selection-change="selectGoods" @row-click="handleRowClick"
      class="tableComent" height="100%" style="width:100%" center border  row-key="orderId" lazy :load="load"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}" v-if="tabHeadList.length>0">
      <el-table-column  type="index" width="55" label="序号" fixed></el-table-column>
         <template v-for="(column,index) in tabHeadList">
          <template v-if="column.enName=='orderNo'">
            <el-table-column property="" :formatter="formatterRowEmpty" :fixed="index<1" width="240" label="订单编号" :key="column.enName">
              <template slot-scope="scope">
                <span class="textColer" @click="detailFn(scope.row)">{{scope.row.orderNo}}</span>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="column.enName=='residualTotalWeight'">
            <el-table-column property="orderSource" label="剩余量" :fixed="index<1"  width="240" :key="column.enName">
              <template scope="scope">
                <div>
                  <div class="textColer" @click="WHSYLFn(scope.row)" v-if="scope.row.goodsYn==1">
                    <span>{{scope.row.residualTotalWeight}}</span>
                  </div>
                  <div v-else>
                    <span>{{scope.row.residualTotalWeight}}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="column.enName=='orderStateName'">
            <el-table-column property="orderSource" label="状态"  :fixed="index<1" width="120" :key="column.enName">
              <template scope="scope">
                <div>
                  <span  style="color: #D51212;" v-if="scope.row.orderState===0">{{scope.row.orderStateName}}</span>
                  <span  style="color: #E99D42;" v-else-if="scope.row.orderState==1">{{scope.row.orderStateName}}</span>
                  <span  style="color: #81B337;" v-else-if="scope.row.orderState==2">{{scope.row.orderStateName}}</span>
                  <span  style="color: #9A9A9A;" v-else-if="scope.row.orderState==3">{{scope.row.orderStateName}}</span>
                  <span v-else>{{scope.row.orderStateName}}</span>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-else-if="column.enName=='urgencyFlagName'">
            <el-table-column property="orderSource" label="提货紧急程度" :fixed="index<1"  width="120" :key="column.enName">
              <template scope="scope">
                <div>
                  <span  style="color: #D51212;" v-if="scope.row.urgencyFlag===2">{{scope.row.urgencyFlagName}}</span>
                  <span  style="color: #E99D42;" v-else-if="scope.row.urgencyFlag==1">{{scope.row.urgencyFlagName}}</span>
                  <span  v-else>{{scope.row.urgencyFlagName}}</span>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column  :key="column.enName" :prop="column.enName" :fixed="index<1" :label="column.cnName" :width="column.fieldWidth" show-overflow-tooltip :formatter="formatterRowEmpty">
              <el-table-column v-for="item in column.child" :key="item.enName" :prop="item.enName" :label="item.cnName" :width="item.fieldWidth" :formatter="formatterRowEmpty">
              </el-table-column>
            </el-table-column>
          </template>
        </template>

        <!-- <el-table-column property="" :formatter="formatterRowEmpty" width="240" label="订单编号">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.orderNo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <span>{{[ "待处理", "处理中", "已处理","已作废"][scope.row.orderState]}}</span>
          </template>
        </el-table-column>
        <el-table-column property="orderSource" label="订单来源">
          <template scope="scope">
            <div>
              <span >{{[ "手动", "转包", "货主端","分段"][scope.row.orderSource]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="orderSource" label="配载方式">
          <template scope="scope">
            <div>
              <span>{{[ "指派", "转包","分段"][scope.row.stowageType]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="payee" :formatter="formatterRowEmpty" width="200" label="托运方"></el-table-column>
        <el-table-column property="productTypeName" :formatter="formatterRowEmpty" width="120" label="货物类型"></el-table-column>
        <el-table-column property="orderWeight" label="订单量" width="120">
          <template scope="scope">
            <div>
              <span v-if="scope.row.orderWeight&&scope.row.orderNumber">
                {{scope.row.orderWeight}}{{scope.row.measuringUnit}}/{{scope.row.orderNumber}}件</span>
              <span v-else>
                {{scope.row.orderWeight}}{{scope.row.measuringUnit}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="orderSource" label="配载量"  width="120">
          <template scope="scope">
            <div>
              <span v-if="scope.row.goodsYn==1">
                {{scope.row.stowageWeight}}{{scope.row.measuringUnit}}/{{scope.row.stowageNumber}}件</span>
              <span v-else>
                {{scope.row.stowageWeight}}{{scope.row.measuringUnit}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="orderSource" label="剩余量"  width="120">
          <template scope="scope">
            <div>
              <div style="color: #0c46a2;cursor: pointer;" @click="WHSYLFn(scope.row)" v-if="scope.row.goodsYn==1">
                <span>
                  {{scope.row.residualWeight}}{{scope.row.measuringUnit}}/{{scope.row.residualNumber}}件</span>
              </div>
              <div v-else>
                  <span>{{scope.row.residualWeight}}{{scope.row.measuringUnit}}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="startDirection" width="180" :formatter="formatterRowEmpty" label="始发流向"></el-table-column>
        <el-table-column property="endDirection" width="180" :formatter="formatterRowEmpty" label="目的流向"></el-table-column>
        <el-table-column width="170" property="arrivalTime" :formatter="dateTimeFormat" label="要求到货时间"></el-table-column>
        <el-table-column property="requiredModel" width="100" :formatter="formatterRowEmpty" label="需求车型"></el-table-column>
        <el-table-column property="needLength" width="100" :formatter="formatterRowEmpty" label="需求车长"></el-table-column>
        <el-table-column property="receiptRequest" width="100" :formatter="formatterRowEmpty" label="回单要求"></el-table-column>
        <el-table-column property="ticketSystemYn" width="100" :formatter="formatterRowEmpty" label="是否一票制"></el-table-column>
        <el-table-column property="makeTicketYn" width="100" :formatter="formatterRowEmpty" label="是否开票"></el-table-column>
        <el-table-column property="revenueValuation" label="收入计价">
          <template scope="scope">
            <div>
              <span>{{[ "按吨", "包车","按方","按件"][scope.row.revenueValuation]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="incomePattern" label="收入方式">
          <template scope="scope">
            <div>
              <span>{{[ "月结", "现结"][scope.row.incomePattern]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="incomeUnitPrice" label="收入单价" width="100">
          <template scope="scope">
            <div>
              {{scope.row.incomeUnitPrice}}元/{{scope.row.measuringUnit}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="incomeAmount" width="120" :formatter="formatterRowEmpty" label="收入金额(元)"></el-table-column>
        <el-table-column property="payer" width="150" :formatter="formatterRowEmpty" label="转包单位"></el-table-column>
        <el-table-column property="expenditurePattern" label="支出方式">
          <template scope="scope">
            <div>
              <span>{{[ "月结", "现结"][scope.row.expenditurePattern]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="freightPricingType" label="运费计价">
          <template scope="scope">
            <div>
              <span>{{["按吨", "包车","按方","按件"][scope.row.freightPricingType]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="freightUnitPrice" label="运费单价" width="120">
          <template scope="scope">
            <div>
              {{scope.row.freightUnitPrice}}元/{{scope.row.measuringUnit}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="freightAmount" width="120" :formatter="formatterRowEmpty" label="运费金额(元)"></el-table-column>
        <el-table-column property="serviceRate" width="100" :formatter="formatterRowEmpty" label="服务费率%"></el-table-column>
        <el-table-column property="serviceCharge" width="120" :formatter="formatterRowEmpty" label="服务费(元)"></el-table-column>
        <el-table-column property="freightTotal" width="120" :formatter="formatterRowEmpty" label="运费总额(元)"></el-table-column>
        <el-table-column property="taxRate" width="100" :formatter="formatterRowEmpty" label="税率%"></el-table-column>
        <el-table-column property="businessUnit" width="120" :formatter="formatterRowEmpty" label="业务部门"></el-table-column>
        <el-table-column property="businessUser" width="120" :formatter="formatterRowEmpty" label="业务人员"></el-table-column>
        <el-table-column property="orderBusinessType" label="项目所属">
          <template scope="scope">
            <div>
              <span >{{[ "外库业务", "本库业务"][scope.row.orderBusinessType]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="发货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#0c46a2">(发){{scope.row.deliverCompany}}</span>
              <span>{{scope.row.deliverPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.deliverPhone}}</span>
              <span>{{scope.row.deliverAddress}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#F56C6C">(收){{scope.row.receivingCompany}}</span>
              <span>{{scope.row.receivingPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.receivingPhone}}</span>
              <span>{{scope.row.receivingAddress}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="externalOrderNumber" :formatter="formatterRowEmpty" width="180" label="外部单号" show-overflow-tooltip></el-table-column>
        <el-table-column property="createUser" width="150" :formatter="formatterRowEmpty" label="创建人"></el-table-column>
        <el-table-column property="createTime" width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column> -->
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 设置表头 -->
    <table-heads v-if="tableMark" :tableMark.sync='tableMark' :groupCode="groupCode" @refresh = 'queryMyPageField'></table-heads>
    <export-setting v-if="exportMark" :exportMark.sync='exportMark' :groupCode="groupCode"
   @exportList='exportList'></export-setting>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { getDictionaryDetailList, findCustomerInfoList, findRecycleOrderList, queryMyPageField, getDictionaryMasterList, findSonSectionList } from '@/api/newTMS'
import { getCurrUserDepartment, getDepartmentUsers } from '@/api/newCrm'
import { formatterRowEmpty, dateTimeFormat, dateFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import tableHeads from '@/views/newTMS/publicFiles/tableHeades.vue'
import exportSetting from '@/views/newTMS/publicFiles/exportSetting.vue'
export default {
  components: {
    tableHeads, exportSetting
  },
  data () {
    return {
      groupCode: 'platformOrder',
      tableMark: false,
      exportMark: false,
      tabHeadList: [],
      formatterRowEmpty: formatterRowEmpty,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      h: 500,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
        // orderStates: '0,1'
      },
      tableList: [],
      total: 0,
      loading: false,
      btnFlg: [],
      btnIdArr: ['01N01D0100', '01N01D0100'],
      kehuList: [],
      isDisable: false,
      customTypes: [],
      importDialog: false,
      CYSList: [], // 承运商
      yonghuList: [],
      zidanList: [],
      SRJJlist: [],
      userName: localStorage.getItem('userName'),
      usertype: null,
      HWlist: [], // 货物名称
      bumenList: [],
      topShow: false,
      searchList: [],
      seacrchNum: window.innerWidth > 1680 ? 9 : 7
    }
  },
  created () {
    if (this.$route.params) {
      this.$set(this.searchFrom, 'orderNo', this.$route.params.orderNo)
    }
    this.btnFlg = getBtn(this.btnIdArr, '/recycleBin')
    this.getList(this.searchFrom)
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    getDictionaryDetailList({ dictionaryType: 'settlement_pricing' }).then(res => { this.SRJJlist = res })
    findCustomerInfoList({ businessType: 1 }).then(res => { this.kehuList = res })
    getCurrUserDepartment().then(res => { this.bumenList = res })
    this.queryMyPageField()
  },

  mounted () {

  },
  methods: {
    getHeight () {
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = (pH - h - 210) + 'px'
      })
    },
    topFn () {
      this.topShow = !this.topShow
      this.getHeight()
      this.seacrchNum = window.innerWidth > 1680 ? 9 : 7
    },
    goodschange (e) {
      this.$set(this.searchFrom, 'productType', null)
      this.$set(this.searchFrom, 'productTypeName', null)
      getDictionaryDetailList({ masterId: e }).then(res => {
        this.HWlist = res
      })
    },
    // 点击运单数量
    yundanFn (row) {
      this.$router.push({ name: 'qiYunWay', params: { orderNo: row.orderNo } })
    },
    bumenChangeCX (e) {
      let json1 = this.bumenList.filter(item => item.name == e)
      getDepartmentUsers({ subOrgCode: json1[0].code }).then(res => { this.yonghuList = res })
    },
    tabSetting () {
      this.tableMark = true
    },
    // 查询我的页面表头
    queryMyPageField () {
      this.tabHeadList = []
      queryMyPageField({
        // 入参：tagCode 分组编码： 订单列表-> orderPage 运单列表-> wayPage 收支列表-> szPage
        tagCode: this.groupCode
      }).then(res => {
        this.tabHeadList = res
        this.searchList = this.tabHeadList.filter(item => item.isSettingQuery == 1)
        this.$nextTick(() => {
          this.getHeight()
        })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    async exportList (val) {
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      form.header = val
      await exportExcel(
        this.global.tmsPlus + '/order/exportRecycleOrderList',
        form,
        '回收站订单列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 导出
    exportFn () {
      this.exportMark = true
    },

    // 运单
    wayFn (row) {
      this.$router.push({ name: 'qiYunOrderSubPlan', query: { id: row.orderId } })
    },
    // 打印
    dayinFN () {
      let selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        this.$router.push({ name: 'tmsOrderDayin', query: { id: selectData[0].orderBusinessId } })
      }
    },
    // 详情
    detailFn (row) {
      this.$router.push({ name: 'qiYunOrderDetails', query: { id: row.orderBusinessId } })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcode) {
        this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.replace(/\n/g, ',')
      } else {
        this.searchFrom.cargoBarcodes = ''
      }
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      if (this.searchFrom.arrivalTimes) {
        this.searchFrom.arrivalTimeStart = this.searchFrom.arrivalTimes[0]
        this.searchFrom.arrivalTimeEnd = this.searchFrom.arrivalTimes[1]
      } else {
        this.searchFrom.arrivalTimeStart = ''
        this.searchFrom.arrivalTimeEnd = ''
      }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0
      var that = this
      selection.forEach((item) => {
        // that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      if (row.orderState != 3) {
        this.$refs.table.toggleRowSelection(row)
      }
    },
    // 获取货物列表
    getList (searchFrom) {
      findRecycleOrderList(searchFrom).then((res) => {
        this.symbolKey = Symbol(new Date().toString())
        this.tableList = []
        res.list.forEach(item => {
          if (item.stowageType == 2) {
            item.children = []
            item.hasChildren = true
          }
          this.tableList.push(item)
        })
        this.total = res.total
      })
    },
    load (tree, treeNode, resolve) {
      findSonSectionList({ orderId: tree.orderId, orderBusinessId: tree.orderBusinessId }).then((res) => {
        resolve(res)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    // 导入
    THimportFn () {
      this.importDialog = true
    },
    destroy () {
      this.importDialog = false
    },
    DRsave (formData) {
      // const loading = this.$loading({
      //   lock: true,
      //   text: '正在处理...'
      // })
      // impOrder(formData).then(res => {
      //   loading.close()
      //   this.importDialog = false
      //   var that = this
      //   this.importMsg = this.$message({
      //     showClose: true,
      //     message: res,
      //     duration: 0,
      //     type: 'success',
      //     onClose () {
      //       loading.close()
      //     }
      //   })
      //   that.getList(that.searchFrom)
      // }).catch(error => {
      //   this.importMsg = this.$message({
      //     showClose: true,
      //     message: error.message,
      //     duration: 0,
      //     type: 'error',
      //     onClose () {
      //       loading.close()
      //     }
      //   })
      // })
    },
    // 状态格式化
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 1002:
          return '待审核'
        case 1004:
          return '已通过'
        case 1101:
          return '议价中'
        case 1201:
          return '待承运'
        case 1202:
          return '承运中'
        case 1203:
          return '已送达'
        case 1301:
          return '已签收'
        default:
          return '已结算'
      }
    }
  },
  activated () {
    if (!this.$route.meta.isBack) { // 清空查询条件
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.getList(this.searchFrom)
    } else {
      this.$route.meta.isBack = false
      this.getList(this.searchFrom)
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.path == '/qiYunOrder/add' || from.path == '/qiYunOrder/edit' || from.path == '/qiYunOrder/details') {
      to.meta.isBack = true
    } else {
      to.meta.isBack = false
    }
    next()
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width: 420px!important;
}
/deep/.el-form{
  width: 100%;
}
.box1 span {
  margin-left: 10px;
  font-size: 12px;
}
.addressBox .title{
  margin-left: 0;
}
.addressBox{
  margin-top:16px;
  margin-bottom: -15px;
}
.red{
color:#F56C6C ;
}
.green{
color:#01884d ;
}
.box{
  width: 100%;
   display: grid;
   grid-template-columns: repeat(auto-fill, 270px);
   grid-auto-flow: row dense;
   /deep/.el-textarea__inner{
    width: 150px;
    height: 68px;
   }
   .item1{
      grid-row-start: span 2;
    }
   .item2{
      grid-column-start: span 2;
      width: 540px;
   }
}
.box3{
  display: flex;
  flex-wrap:wrap;
  .box31{
    min-width: 300px;
  }
  p{
    margin-right: 20px;
    margin-top: 0;
  }
}
.box1{
  text-align: right;
  padding-right: 60px;
  /deep/ .icon{
    font-size: 24px;
    color:#0c46a2 ;
  }
}
.fujianBox{
  display: flex;
  flex-direction: column;
  /deep/.el-button--text{
    text-align: left;
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.dayinBox{
  padding: 10px;
}
.sytable {
  border-collapse: collapse;
}
.sytable,
.sytable th,
.sytable td {
  border: 1px solid #666;
}
.sytable {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  td {
    text-align: center;
    height: 30px;
  }
  .td1{
    width: 120px;
  }
  .td3{
    width:30%;
  }
  .td2{
    width:50%;
  }
}
.table_title p{
  text-align: center;
  font-size: 22px;
}
/deep/.jiaoyan .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
/deep/.el-table tbody .jihuahao .cell{
 text-align: left;
}

</style>
